import { Box, BoxProps } from "@chakra-ui/react";
import { FiBook } from "react-icons/fi";

export const BookIcon = (props: BoxProps) => {
  return <Box as={FiBook} height="20px" width="20px" {...props} />;
};
